// Local translations
export const T = {
  en_GB: {
    remove: "Remove",
    chooseIcon: "Choose icon",
    uploadSvg: "Upload SVG",
    clearIcon: "Clear icon",
    pickerTitle: "Choose an icon",
    searchPlaceholder: "Search icons...",
    loadingIcons: "Loading icons...",
    noMatches: "No icons match your search",
    loadFailed: "Could not load the icon library",
    showingOf: (shown: number, total: number) =>
      `Showing ${shown} of ${total} icons — type to narrow down`,
    invalidSvg: "The file does not look like an SVG (no <svg> tag found)",
    readFailed: "Could not read the file",
  },
  nb_NO: {
    remove: "Fjern",
    chooseIcon: "Velg ikon",
    uploadSvg: "Last opp SVG",
    clearIcon: "Fjern ikon",
    pickerTitle: "Velg et ikon",
    searchPlaceholder: "Søk etter ikoner...",
    loadingIcons: "Laster ikoner...",
    noMatches: "Ingen ikoner samsvarer med søket",
    loadFailed: "Kunne ikke laste ikonbiblioteket",
    showingOf: (shown: number, total: number) =>
      `Viser ${shown} av ${total} ikoner — skriv for å avgrense`,
    invalidSvg: "Filen ser ikke ut som en SVG (fant ingen <svg>-tagg)",
    readFailed: "Kunne ikke lese filen",
  },
} as const;
